/***
 * cookie for auth => 30 days
 * cookie for guest => 1 day
 */

export const USER_COOKIE_KEY = "WEAVR_WALLET_STATE"
export const WHITELIST_COOKIE_KEY = "WHITELIST_COOKIE_KEY"
